import { Button, Dialog } from "@luce/ui";

import { useChangePhoneNumberContext } from "../change-phone-number-context";

export function CancelChangePhoneNumberModal() {
  const { step, resumeOtp, exit } = useChangePhoneNumberContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) resumeOtp();
  };

  return (
    <Dialog.Root open={step === "cancel"} onOpenChange={handleOpenChange} size="md">
      <Dialog.Header>
        <Dialog.Title>Cancel change phone number</Dialog.Title>
        <Dialog.Description>
          Are you sure you want to cancel? This action will discard your changes
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Footer layout="stacked">
        <Button
          variant="secondary"
          size="lg"
          fullWidth
          label="Yes, I want to cancel"
          onClick={exit}
        />
        <Button size="lg" fullWidth label="No, I want to change number" onClick={resumeOtp} />
      </Dialog.Footer>
    </Dialog.Root>
  );
}
